
export default {
    environment: window.DATA ? window.DATA.environment : 'DEVELOPMENT',
}
